"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var use_theme_1 = __importDefault(require("../../../global/use-theme"));
var styled_components_1 = __importDefault(require("styled-components"));
var Svg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  top: ", ";\n  position: relative;\n  z-index: 3;\n  margin: ", ";\n  transform: translateY(1px);\n"], ["\n  top: ", ";\n  position: relative;\n  z-index: 3;\n  margin: ",
    ";\n  transform: translateY(1px);\n"])), function (_a) {
    var offset = _a.offset;
    return (offset === 0 ? 0 : (offset / 2 + 1) * -1) + "px";
}, function (_a) {
    var side = _a.side, offset = _a.offset;
    return "0 " + (side === 'right' ? (offset === 0 ? '8px' : '8px') : '0') + " 0 " + (side === 'left' ? (offset === 0 ? '8px' : '8px') : '0px');
});
var Dash = function (_a) {
    var side = _a.side, offset = _a.offset;
    var colours = use_theme_1.default().colours;
    var width = 26;
    var smallWidth = width / 2;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        side === 'left' && offset !== 0 && (react_1.default.createElement(Svg, { offset: offset, side: side, height: offset, width: width, stroke: colours.installationSketch.stroke, strokeWidth: 2, fill: 'none', viewBox: "0 " + offset * -1 + " " + width + " " + offset + " " },
            react_1.default.createElement("g", null,
                react_1.default.createElement("path", { d: "M 0 0 l " + smallWidth + " 0 v " + offset * -1 + " l " + smallWidth + " 0 " })))),
        side === 'right' && offset !== 0 && (react_1.default.createElement(Svg, { offset: offset, side: side, height: offset, width: width, stroke: colours.installationSketch.stroke, strokeWidth: 2, fill: 'none', viewBox: width * -1 + " " + offset * -1 + " " + width + " " + offset + " " },
            react_1.default.createElement("g", null,
                react_1.default.createElement("path", { d: "M 0 0 l " + smallWidth * -1 + " 0 v " + offset * -1 + " l " + smallWidth * -1 + " 0 " })))),
        offset === 0 && (react_1.default.createElement(Svg, { offset: offset, side: side, height: 2, width: width, stroke: colours.installationSketch.stroke, strokeWidth: 2, fill: 'none' },
            react_1.default.createElement("g", null,
                react_1.default.createElement("path", { d: "M 0 0 l " + width + " 0" }))))));
};
Dash.displayName = 'DashComponent';
exports.default = Dash;
var templateObject_1;
